import styled from '@emotion/styled'

import { breakpoints } from '../../utils/styles'

export const Wrapper = styled.div`
  /* background: rgb(20, 47, 31); */
  background: #f8dcab;
  /* background: linear-gradient(to bottom, #e9ca6f 0%, #dcd0af 100%); */
  /* color: white; */
  color: rgb(20, 47, 31);
  /* color: #f8dcab; */
  padding: 100px 0;
  width: 100%;

  @media (max-width: ${breakpoints.s}px) {
    padding: 60px 0;
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 1400px;
  margin-bottom: 50px;
  text-align: center;

  a {
    color: currentColor;
    text-decoration: none;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem;
  position: relative;
  padding: 0 2.5rem;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .product:nth-child(2) {
    margin-top: 5rem;
  }

  .product:nth-child(3) {
    margin-top: -5rem;
  }

  p {
    font-size: 18px;
    margin-bottom: 30px;
    line-height: 1.6;
    margin-top: 0;
  }

  a {
    /* color: white; */
    /* color: rgb(20, 47, 31); */
    /* color: #f8dcab; */
    color: currentColor;
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 0 20px;

    p {
      font-size: 16px;
    }
  }
`

export const Thumbnail = styled.div`
  background-size: cover;
  width: 100%;
  background-position: center center;
  position: relative;

  &:before {
    content: '';
    padding-top: 66%;
    display: block;
  }
`

export const Subheading = styled.p`
  font-size: 20px;
  max-width: 700px;
  margin: 0 auto;
`
